export const packConfigForCheckingAvailability = [
    "PFPF",
    "PFF",
    'PFP',
    'PF',
    'HS',
    'PFPTTF',
    'PFTTF',
    'PFTT',
    'PFPCS',
    'PFCS',
    'CVPD',
    'CVDP',
    'CVPC',
    'CVAL',
    // 'PMA', // for whatever reason PMA for season=H still returns some availability, breaking the planner a bit, and PMA as a package is now no longer offered, so I will simply comment this out
]